import { TableColumnItem, TableColumnTypeEnum } from '@ui-lib/components';

export const getMaintenanceTableColumnsConfig = (): TableColumnItem[] => [
  {
    propName: 'createdDate',
    captionTranslateKey: 'monitoring.maintenance.column.createdAt',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'status',
    captionTranslateKey: 'monitoring.maintenance.column.status',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'maintenanceType',
    captionTranslateKey: 'monitoring.maintenance.column.maintenanceType',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'facilityName',
    captionTranslateKey: 'monitoring.maintenance.column.facility',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'serviceCenterName',
    captionTranslateKey: 'monitoring.maintenance.column.serviceCenter',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'warrantyType',
    captionTranslateKey: 'monitoring.maintenance.column.warrantyType',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'error',
    captionTranslateKey: 'monitoring.maintenance.column.error',
    type: TableColumnTypeEnum.Text,
  },
];
